var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"err"},[_c('img',{attrs:{"src":"https://lvshuhualv.oss-cn-hangzhou.aliyuncs.com/static/expire.png"},on:{"click":function($event){return _vm.$router.replace({ path: '/login' })}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }